import { END_OF_WS_SECTION } from "../IssueCard";

export const getEndOfIssueRefId = (issueId: string) => {
    return `${issueId}-${END_OF_WS_SECTION}`
}
